import BaseObject from '../../../../base/base_object';
import Model from './url_scheme_model';
import {SCHEME} from './url_scheme_consts';
import {SYSTEM_EVENTS} from '../../../../events/events';
import {SERIVCES_FUNC_LIST, FEATURE_CB_FUNC, KEY_NAME} from '../../native/native_const';
import Event from '../../../../utils/event';
import _ from '../../../../utils/underscore';
import {convertQueryStringToObject} from './url_schema__params_map';


/**
 *
 *
 */
class UrlScheme extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'UrlScheme';

    _model = null;
    _HybridService = null;

    init(params) {
        super.init();

        this._model = Model.create(params);

        this._subscribe();
    }

    _subscribe() {
        Event.on(SYSTEM_EVENTS.ON_INIT_COMPLETE, this._getInfoUrlScheme, this);
    }

    /**
     * get Info UrlScheme - check at init if the hybrid was launched from UrlScheme
     */
    _getInfoUrlScheme() {
        this._HybridService.getInfoUrlScheme().then(data => {
            let dataDecode = _.safeJSONandDecode(data);

            this.onHybridDirectCall(dataDecode[KEY_NAME.DATA]);
        });
    }

    /**
     * onHybridDirectCall - that function is called each time when the app is hybrid is called by the url scheme
     * and the UrlSchcme class call the currect feature with the data.
     * example data:
     * info:{\"hybridcbfeaturefunc\":\"UrlSchemeFeature\",\"id\":\"com.hybridcgp.rl\",\"data\":\"com.hybridcgp.rl://%7B%22type%22%3A%22HybridInfoFeature%22%2C%22action%22%3A%22debug%22%2C%22url%22%3A%22https%3A%2F%2Fcasino-devtouch.888sport.com%3A82%22%2C%22reload%22%3A%22true%22%7D\"}"
     * casheir:{\"hybridcbfeaturefunc\":\"UrlSchemeFeature\",\"id\":\"com.hybridcgp.rl\",\"data\":\"com.hybridcgp.rl://%7b%22type%22%3a%22webviewmanagerfeature%22%2c%22action%22%3a%22closesafari%22%2c%22webid%22%3a1000%7d\"}
     */
    onHybridDirectCall(data) {// casheir info

        if(this._isDeepLink(data)){
            this._updateDeepLinkAndCallFeature(data);
        }else {
            this._updateAndCallFeature(data);
        }
    }

    _isDeepLink(data){

        if(data[KEY_NAME.DATA] && data[KEY_NAME.DATA].includes(SCHEME.IS_DEEP_LINK)) {
            return this._model.setDeepLinkData(data[KEY_NAME.DATA],this._HybridService);
        }

        return false;
    }
    /**
     *  convert DeepLink Data to be like scheme format
     */
    _updateDeepLinkAndCallFeature(data){
        this.clearUrlScheme();
        this.onHybridUrlScheme();
    }
    /**
     * update And Call Feature - call the currect feature
     */
    _updateAndCallFeature(data) {
        data[KEY_NAME.DATA] = convertQueryStringToObject(data[KEY_NAME.DATA]);
        this._model.setInfoUrlScheme(data);
        this.clearUrlScheme();
        this.onHybridUrlScheme();
    }

    initFeatures(hybridSrv) {
        this._HybridService = hybridSrv;
        hybridSrv.setCbFunction(SERIVCES_FUNC_LIST.URL_SCHEME_SET_CB, FEATURE_CB_FUNC.HYBRID_URL_SCHEME_CALL);

        return this;
    }

    /**
     * call the correct feature from the urlscheme
     */
    onHybridUrlScheme() {
        let name = this._model.getFeatueName();
        let data = this._model.getFeatureData();
        this._HybridService.onHybridUrlScheme(name, data);
    }

    clearUrlScheme() {
        this._HybridService.clearUrlScheme();
    }

}

export default UrlScheme;
